// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1ivsn","search":"Settings_search__VBLyc","filter":"Settings_filter__3nA7W"};